function itemHtml(ctx, it) {
    return `<div class="fq-acc">
    <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}"><span>${it.q}</span>${ctx.icon}</button>
    <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
  </div>`;
}
const cove = {
    id: 'cove',
    name: 'Cove',
    tag: 'Split accordion',
    styleTag: 'Soft & spacious',
    description: 'A generous introduction beside a stack of softly rounded answers. A calm, welcoming FAQ for product pages, studios, and service businesses.',
    layout: 'accordion',
    defaultAccent: '#0e8074',
    darkDefault: false,
    catSupport: 'optional',
    features: ['accordion'],
    render(ctx) {
        return {
            html: `<div class="fq-wrap">
        <div class="fq-head"><span class="fq-mark" aria-hidden="true">?</span><h2 class="fq-title">${ctx.title}</h2>${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}</div>
        <div class="fq-main">${ctx.groups.map((g) => `<div class="fq-group">${g.name ? `<h3 class="fq-cat">${g.name}</h3>` : ''}${g.items.map((it) => itemHtml(ctx, it)).join('')}</div>`).join('')}</div>
      </div>`,
            css: `
.FQM .fq-wrap{max-width:980px;margin:0 auto;display:flex;flex-wrap:wrap;gap:32px 56px;align-items:flex-start;overflow-wrap:anywhere}
.FQM .fq-head{flex:1 1 240px;min-width:0}
.FQM .fq-mark{display:grid;place-items:center;width:48px;height:48px;margin-bottom:22px;border-radius:${ctx.v.radius};background:${ctx.v.soft};color:${ctx.v.accent};font-family:${ctx.v.head};font-size:28px}
.FQM .fq-title{margin:0 0 14px;font-family:${ctx.v.head};font-size:38px;font-weight:650;line-height:1.12;letter-spacing:-.025em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.7;color:${ctx.v.sub}}
.FQM .fq-main{flex:2 1 340px;min-width:0}
.FQM .fq-group+.fq-group{margin-top:26px}
.FQM .fq-cat{margin:0 0 12px;font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:${ctx.v.sub}}
.FQM .fq-acc{margin-bottom:10px;border:1px solid ${ctx.v.border};border-radius:${ctx.v.radiusCard};background:${ctx.v.card};transition:border-color .2s,background .2s}
.FQM .fq-acc.fq-open{border-color:${ctx.v.accent};background:${ctx.v.soft}}
.FQM .fq-qbtn{display:flex;align-items:center;justify-content:space-between;gap:18px;width:100%;padding:21px 22px;font-size:16px;font-weight:600;line-height:1.5;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:13px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 22px 22px;font-size:15px;line-height:1.7;color:${ctx.v.sub}}
`,
        };
    },
};
export default cove;
